import { Outlet } from 'react-router';

/** Leave page shell. Width follows the platform Helpdesk container. */
export function LeaveLayout() {
  return (
    <div className="w-full min-w-0 space-y-6">
      <Outlet />
    </div>
  );
}
